
import React, { useState, useContext, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  Typography,
  Box,
  IconButton,
  Divider,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import axiosInstance from "api/axiosInstance";
import { LanguageContext } from "../../../../context/LanguageContext";

import { country_tel } from "../../../../api/authApi";

function CreatorRegistrationDialog({ open, onClose, onSuccess }) {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("CreatorRegistrationDialog", "strategy/CreatorRegistrationDialog/CreatorRegistrationDialog_lang");
  }, [language, loadLanguageFile]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await country_tel();
        setCountries(res.data);
      } catch (error) {
        console.error("❌ 取得國家代碼失敗", error);
      }
    };
    if (open) {
      fetchCountries();
    }
  }, [open]);

  const LANGUAGE = componentLanguageData.CreatorRegistrationDialog || { Main: {} };

  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [formData, setFormData] = useState({
    country: "",
    phone: "",
    address: "",
    paypalEmail: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.phone || !formData.address || !formData.paypalEmail) {
      alert(LANGUAGE.Main.ErrorMissingFields || "請填寫所有欄位");
      return;
    }
    setLoading(true);
    try {
      await axiosInstance.post("/creator/register", formData);
      onSuccess();
      onClose();
    } catch (error) {
      console.error("註冊失敗", error);
      alert(error.response?.data?.message || LANGUAGE.Main.ErrorRegistrationFailed || "註冊失敗，請稍後再試");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: { borderRadius: 3 } }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
        <MDTypography variant="h5" fontWeight="medium">
          {LANGUAGE.Main.Title}
        </MDTypography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider sx={{ my: 0 }} />
      <DialogContent>
        <Box mb={2}>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {LANGUAGE.Main.Description}
          </Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Autocomplete
              options={countries}
              value={selectedCountry}
              onChange={(event, newValue) => {
                setSelectedCountry(newValue);
                setFormData((prev) => ({
                  ...prev,
                  country: newValue?.country || "",
                }));
              }}
              getOptionLabel={(option) =>
                typeof option === "object" && option?.country
                  ? `${option.country} (${option.phoneNumber ? "+" + option.phoneNumber : ""})`
                  : ""
              }
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  label={LANGUAGE.Main.Country} 
                  fullWidth 
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={LANGUAGE.Main.Phone}
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder={LANGUAGE.Main.PhonePlaceholder}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={LANGUAGE.Main.Address}
              name="address"
              value={formData.address}
              onChange={handleChange}
              multiline
              rows={2}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={LANGUAGE.Main.PayPal}
              name="paypalEmail"
              type="email"
              value={formData.paypalEmail}
              onChange={handleChange}
              placeholder={LANGUAGE.Main.PayPalPlaceholder}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <MDButton variant="text" color="secondary" onClick={onClose}>
          {LANGUAGE.Main.CancelButton}
        </MDButton>
        <MDButton
          variant="gradient"
          color="info"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "..." : LANGUAGE.Main.RegisterButton}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

export default CreatorRegistrationDialog;
